import FundIcon from '@material-ui/icons/AccountBalanceWallet';
import FundList from './FundList';
import FundEdit from './FundEdit';
import FundCreate from './FundCreate';

export default {
  list: FundList,
  edit: FundEdit,
  create: FundCreate,
  icon: FundIcon
};
